import { render, staticRenderFns } from "./sdgGoalsDisplay.vue?vue&type=template&id=1e79c761&scoped=true"
import script from "./sdgGoalsDisplay.vue?vue&type=script&lang=js"
export * from "./sdgGoalsDisplay.vue?vue&type=script&lang=js"
import style0 from "./sdgGoalsDisplay.vue?vue&type=style&index=0&id=1e79c761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e79c761",
  null
  
)

export default component.exports